"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = EADebugPanel;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _TrackRecordView = _interopRequireDefault(require("./views/TrackRecordView"));
var _ConfigureView = _interopRequireDefault(require("./views/ConfigureView"));
var _MainView = _interopRequireDefault(require("./views/MainView"));
var _defaultPanelStyle = _interopRequireDefault(require("./style/defaultPanelStyle"));
var _EAPropTypes = _interopRequireDefault(require("./style/props/EAPropTypes"));
var _storage = _interopRequireWildcard(require("./storage/storage"));
var _useHackilyHideRestOfPopoutPage = _interopRequireDefault(require("./utils/useHackilyHideRestOfPopoutPage"));
var _modes = require("./constants/modes");
var SESSION_CONFIG_KEY = 'config-session';
function EADebugPanel(_ref) {
  var _ref$trackRecords = _ref.trackRecords,
    trackRecords = _ref$trackRecords === void 0 ? [] : _ref$trackRecords,
    mode = _ref.mode,
    clearTrackRecords = _ref.clearTrackRecords,
    weSdkVersion = _ref.weSdkVersion,
    defaultRelevantFields = _ref.defaultRelevantFields;
  // Set by a click on one of the rows in the Fired Pixels sections
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    trackRecordToView = _useState2[0],
    setTrackRecordToView = _useState2[1];

  // Set by a click on the "Configure" button
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showConfigureView = _useState4[0],
    setShowConfigureView = _useState4[1];
  var _useState5 = (0, _react.useState)(defaultRelevantFields),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    relevantFieldsConfig = _useState6[0],
    setRelevantFieldsConfig = _useState6[1];
  var currentStyle = (0, _objectSpread2["default"])({}, _defaultPanelStyle["default"]);
  var _useState7 = (0, _react.useState)({
      currentStyle: currentStyle
    }),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    style = _useState8[0],
    setStyle = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    panelCollapsed = _useState10[0],
    setPanelCollapsed = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    panelActive = _useState12[0],
    setPanelActive = _useState12[1];
  var eaDebugRef = (0, _useHackilyHideRestOfPopoutPage["default"])(mode);
  var DebugPanelParent = function DebugPanelParent(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: eaDebugRef // `eaDebugRef` is passed as a "callback ref" from useHackilyHideRestOfPopoutPage - https://medium.com/welldone-software/usecallback-might-be-what-you-meant-by-useref-useeffect-773bc0278ae
      ,

      className: "ekoanalytics-debug-panel",
      style: style.currentStyle
    }, children);
  };
  if (mode === _modes.MODES.POPOUT) {
    currentStyle = Object.assign({}, currentStyle, {
      height: '100%',
      width: '100%'
    });
  }

  // If we're in "view single record" mode, just show that single TrackRecordView!
  if (trackRecordToView) {
    return /*#__PURE__*/_react["default"].createElement(DebugPanelParent, null, /*#__PURE__*/_react["default"].createElement(_TrackRecordView["default"], {
      trackRecord: trackRecordToView,
      onExitClick: function onExitClick() {
        return setTrackRecordToView(null);
      }
    }));
  }

  // If we're in the "configure relevant events" view, show that view!
  if (showConfigureView) {
    return /*#__PURE__*/_react["default"].createElement(DebugPanelParent, null, /*#__PURE__*/_react["default"].createElement(_ConfigureView["default"], {
      relevantFieldsConfig: relevantFieldsConfig || 'Fetching default relevant fields',
      onSaveAndExitClick: function onSaveAndExitClick(newRelevantFieldsConfig) {
        setShowConfigureView(false);
        setRelevantFieldsConfig(newRelevantFieldsConfig);
        var storage = (0, _storage["default"])(_storage.storageTypes.SESSION);
        var config = JSON.parse(storage.getItem(SESSION_CONFIG_KEY));
        if (config) {
          config.defaultRelevantFields = newRelevantFieldsConfig;
          storage.setItem(SESSION_CONFIG_KEY, JSON.stringify(config));
        }
      },
      onCancel: function onCancel() {
        return setShowConfigureView(false);
      },
      setRelevantFieldsConfig: setRelevantFieldsConfig
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(DebugPanelParent, null, /*#__PURE__*/_react["default"].createElement(_MainView["default"], {
    trackRecords: trackRecords,
    clearTrackRecords: clearTrackRecords,
    weSdkVersion: weSdkVersion,
    relevantFieldsConfig: relevantFieldsConfig,
    setShowConfigureView: setShowConfigureView,
    setTrackRecordToView: setTrackRecordToView,
    panelCollapsed: panelCollapsed,
    setPanelCollapsed: setPanelCollapsed,
    panelActive: panelActive,
    setPanelActive: setPanelActive,
    setStyle: setStyle
  }));
}